import { colors, layout } from '../NewHire/v2/styles';
import { AnnualReviewStepDescriptor } from './types';

interface WelcomeScreenProps {
  steps: AnnualReviewStepDescriptor[];
  completedKeys: Set<string>;
  userName?: string;
  cycleYear: number;
  onStart: () => void;
}

const WelcomeScreen = ({ steps, completedKeys, userName, cycleYear, onStart }: WelcomeScreenProps) => {
  const visible = steps.filter((s) => s.key !== 'review_submit');
  const total = visible.length;
  const completed = visible.filter((s) => completedKeys.has(s.key)).length;
  const allDone = total > 0 && completed === total;
  const startLabel = allDone ? 'Review & Submit' : completed > 0 ? 'Continue' : 'Start Annual Review';

  return (
    <div style={layout.page}>
      <div style={{ ...layout.container, maxWidth: 720 }}>
        <div style={{ ...layout.card, textAlign: 'center', padding: '40px 32px' }}>
          <div
            style={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              background: colors.accentSoft,
              margin: '0 auto 16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 28,
              color: colors.accent,
            }}
          >
            <i className="fas fa-clipboard-list" />
          </div>
          <h1 style={{ fontSize: 26, fontWeight: 700, margin: 0 }}>Your {cycleYear} Annual Review</h1>
          {userName ? (
            <div style={{ fontSize: 14, color: colors.text, marginTop: 6, fontWeight: 700 }}>{userName}</div>
          ) : null}
          <p style={{ color: colors.muted, marginTop: 10, fontSize: 14 }}>
            Click below to begin. You will be guided through a few short sections — feel free to save and continue later
            from this same link.
          </p>
          <button
            type="button"
            onClick={onStart}
            style={{ ...layout.primaryBtn, marginTop: 20, width: '100%', padding: 14 }}
          >
            {startLabel}
          </button>
          <div style={{ fontSize: 12, color: colors.muted, marginTop: 10 }}>
            Your progress will be saved automatically as you go
          </div>

          {total > 0 ? (
            <div style={{ marginTop: 24, fontSize: 13, color: colors.muted }}>
              {completed} of {total} sections complete
            </div>
          ) : null}

          <div style={{ marginTop: 14, textAlign: 'left' }}>
            {visible.map((step, idx) => {
              const done = completedKeys.has(step.key);
              return (
                <div
                  key={step.key}
                  style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 14,
                    padding: '14px 16px',
                    background: '#F9FAFB',
                    border: `1px solid ${colors.border}`,
                    borderRadius: 10,
                    marginBottom: 10,
                  }}
                >
                  <div
                    style={{
                      width: 28,
                      height: 28,
                      borderRadius: '50%',
                      background: done ? colors.success : '#E5E7EB',
                      color: done ? '#fff' : '#6B7280',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 13,
                      fontWeight: 600,
                      flexShrink: 0,
                    }}
                  >
                    {done ? <i className="fas fa-check" /> : idx + 1}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 600, fontSize: 14 }}>{step.title}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
